import { useCallback, useEffect, useState } from 'react';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { Wrapper } from '@styles/CommonStyles';
import { useLenderELTEditorColumns } from './hooks/useLenderELTEditorColumns';
import { useLenderELTCodes } from './hooks/useLenderELTCodes';
import { deleteEltCodeRequest } from './requests';
import { AddEltCodeModal } from './AddEltCodeModal';
import { TLenderELTSpecificEltCodes } from './interfaces';

export const LenderELTEditor = () => {
  const { columns } = useLenderELTEditorColumns();
  const { lenderELTCodes, error, refetchLenderELTCodes } = useLenderELTCodes();

  const [currentEltCode, setCurrentEltCode] = useState<null | TLenderELTSpecificEltCodes>(null);
  const [eltCodeModalPosition, setEltCodeModalPosition] = useState(0);

  const gridActions = {
    onDelete: (data: TLenderELTSpecificEltCodes & { lenderId: string }) => deleteEltCodeRequest(data.lenderId, data.state),
    onEdit: (data: TLenderELTSpecificEltCodes) => {
      setCurrentEltCode(data);
      setEltCodeModalPosition(prevState => prevState + 1);
    },
  };

  const handleClose = useCallback(() => {
    setCurrentEltCode(null);
    setEltCodeModalPosition(0);
  }, []);

  const handleOnButtonClick = useCallback(() => {
    setEltCodeModalPosition(prevState => prevState + 1);
    setCurrentEltCode({} as TLenderELTSpecificEltCodes);
  }, []);

  useEffect(() => {
    refetchLenderELTCodes();
  }, [lenderELTCodes]);

  return (
    <Wrapper>
      <PhoenixGrid
        autoHeight
        canNotCopy
        strict
        withHeader
        showClearAllFilter
        actions={gridActions}
        buttonTitle="Add New Lender ELT Code"
        columns={columns}
        name="Lender ELT Codes"
        loading={!lenderELTCodes && !error}
        rows={lenderELTCodes}
        onButtonClick={handleOnButtonClick}
      />

      <AddEltCodeModal
        open={!!currentEltCode}
        currentEltCode={currentEltCode}
        eltCodeModalPosition={eltCodeModalPosition}
        refetchLenderELTCodes={refetchLenderELTCodes}
        handleClose={handleClose}
      />
    </Wrapper>
  );
};
